<template>
    <NoButtonModal :open="true" @close="$emit('cancel')">
        <button class="close-corner-x" type="button" @click.prevent="$emit('cancel')">
            <span class="material-icons-outlined dark-text">close</span>
        </button>
        <h1>Revoke Alert</h1>
        <p>Are you sure you want to revoke this Extended Member?</p>
        <button @click="$emit('cancel')" class="button secondary">Cancel</button>
        <button @click="$emit('save')" class="button primary">Revoke</button>
    </NoButtonModal>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';

    export default {
        name: 'ExtendedMemberRevokeAlert',
        components: { NoButtonModal },
    };
</script>
